/**
 * Created by or_p on 10/8/2016.
 */
import PropTypes from 'prop-types';

import React, { Component } from 'react';

export default class InlineStyle extends Component {
  render() {
    const {css} = this.props;
    /*
      Wrapping css with html comments is a workaround for TinyMCE behavior where it comments out style element content
     */
    return (
      <style dangerouslySetInnerHTML={{__html: `<!---->${css}<!---->`}}/>
    );
  }
}

InlineStyle.propTypes = {
  css: PropTypes.string.isRequired,
};